import { List, Spin, Table } from 'antd';

const ResponsiveDataTable = ({ columns, dataSource = [], loading = false }) => {
  return (
    <div>
      <div className="hidden lg:block">
        <Table columns={columns} dataSource={dataSource} loading={loading} />
      </div>
      <div className="lg:hidden">
        {loading ? (
          <div className="flex justify-center items-center mt-10">
            <Spin />
          </div>
        ) : (
          <List
            dataSource={dataSource}
            renderItem={(item) => (
              <List.Item>
                <table className="w-full bg-white">
                  <tbody>
                    {columns.map((column, key) => (
                      <tr key={key} className="border">
                        <th className="p-3">{column.title}</th>
                        <td className="text-right flex justify-end p-3">
                          {typeof column.render === 'function'
                            ? column.render(item[columns.dataIndex], item)
                            : item[column.dataIndex]}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </List.Item>
            )}
          />
        )}
      </div>
    </div>
  );
};

export default ResponsiveDataTable;
